export const login = "/auth/login"; //post
export const me = "/me"; //get & post & put
export const userAvatar = "me/avatar"; //post
export const logout = "/auth/logout"; //post
export const app = "/api/app"; //get
export const register = "/auth/user/register"; //post
export const resetRequest = "/auth/password-reset-request"; ///post
export const setPassword = "/auth/password-reset";
